<div class="textarea-container" [formGroup]="form">
	<mat-form-field
		class="no-underline no-hint"
		[class.dark-color]="darkMode"
		[class.form-control]="darkMode"
		[class.form-field]="darkMode"
		appearance="fill"
		[floatLabel]="floatLabel"
	>
		<mat-label *ngIf="label">{{ label }}</mat-label>
		<textarea
			matInput
			#textInput
			cdkTextareaAutosize
			[disabled]="isDisabled"
			[name]="controlName"
			[formControlName]="controlName"
			[placeholder]="placeholder"
			[cdkAutosizeMinRows]="minRows"
			[cdkAutosizeMaxRows]="maxRows"
			[maxlength]="maxLength"
		></textarea>
	</mat-form-field>

	<app-writing-tools
		*ngIf="showWritingTools"
		[value]="form.get(controlName)?.value"
		(valueChanged)="form.get(controlName)?.setValue($event)"
	></app-writing-tools>

	<div *ngIf="hint" class="input-hint">{{ hint }}</div>
</div>
